import axios from "axios";
import urls from "../../urls";

export const sendCustomerRequestRejectedMail = (object) => {
  return new Promise((resolve, reject) => {
    axios
      .post(urls.sendCustomerRequestRejectedMail, object)
      .then((result) => {
        resolve(result);
      })
      .catch((err) => reject(err));
  });
};

export const inviteUser = (user, token, isAdmin = false) => {
  return new Promise((resolve, reject) => {
    const config = {
      headers: { Authorization: token },
    };

    const endpoint = isAdmin ? urls.sendInvite : urls.inviteNewAppUser;

    axios
      .post(endpoint, user, config)
      .then((result) => {
        resolve(result);
      })
      .catch((err) => reject(err));
  });
};
